import HttpServer from "../httpServer";

export default {
  sendRegisterCode(params) {
    return HttpServer.get(`/prod-api/recruitment/user/registerSendCode`, params);
  },
  sendEmailCode(params) {
    return HttpServer.get(`/prod-api/recruitment/user/backCode`, params);
  },
  changePassword(params) {
    return HttpServer.post(`/prod-api/recruitment/user/changePwd`, params);
  },
  // 账号相关
  register(params) {
    return HttpServer.post(`/prod-api/recruitment/user/register`, params);
  },
  login(params) {
    return HttpServer.post(`/prod-api/recruitment/user/login`, params);
  },
  logout() {
    return HttpServer.delete(`/prod-api/recruitment/user/logout`);
  },
  code() {
    return HttpServer.get(`/prod-api/code`);
  },
  getUserInfo() {
    return HttpServer.get(`/prod-api/recruitment/user/findUserInfo`, null, {
      notShowMessage: true,
    });
  },
};
